import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import CustomerServiceAgreementCheckbox from "./CustomerServiceAgreementCheckbox";
import { CartModel } from "atoms/models";
import { agreeWithCustomerTermsState } from "atoms";
import { useRecoilValue } from "recoil";

const CustomerServiceAgreementModal: React.FC<{ cart: CartModel; onContinue: Function }> = ({ cart, onContinue }) => {
  const [serviceAgreementModal, setServiceAgreementModal] = useState(false);
  const agreeWithCustomerTerms = useRecoilValue(agreeWithCustomerTermsState);
  return (
    <>
      <Button
        variant="primary"
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault();
          setServiceAgreementModal(true);
        }}
        className={agreeWithCustomerTerms ? "me-2 mb-2 monthly-subscription-terms-button-checked" : "me-2 mb-2 monthly-subscription-terms-button"}
      >
        Monthly Subscription Terms
      </Button>
      <Modal show={serviceAgreementModal} onHide={() => setServiceAgreementModal(false)} className="customer-service-agreement-modal" size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Monthly Subscription Terms</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <strong>Monthly Subscription:</strong> All services and use of Comporium equipment are provided on a recurring monthly basis which will
            automatically renew on the first day of your next monthly billing cycle. You are responsible for the full monthly charge, and unless you
            cancel the service(s) on or before the last day of your monthly billing period, you will be charged in full for the next month.
          </p>

          <p>
            <strong>Trial Offers:</strong> If you are receiving a trial offer for an initial term, charges will increase at the end of the trial
            period and then continue on a monthly recurring basis until you cancel service.
          </p>

          <p>
            <strong>Amount:</strong> You acknowledge that you have been provided with and agree with the amount or range or recurring charges.
          </p>

          <p>
            <strong>Cancellation:</strong> You may cancel any service online through your My Comporium account, by calling customer service&nbsp;
            <a href="tel:+18884032667">(888) 403-2667</a>, or in person at any Comporium retail store.
          </p>
          <CustomerServiceAgreementCheckbox cart={cart} setServiceAgreementModal={setServiceAgreementModal} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CustomerServiceAgreementModal;
